import React, {useEffect, useState} from 'react'
import { TableWrapper } from '../../../libs/react-mpk/wrapper'
import Modal from '../../../libs/react-mpk/components/Modal'
import t from 'counterpart'
import service from './Entitas.service'
import moment from 'moment'
import { toast } from '../../../libs/react-mpk/services'
import { inject, observer } from 'mobx-react'

var _baseId = "mod-table-entitas"

const EntitasTable = ({
  className       = '',
  showCommandbar  = true,
  history,
  sipStore,
  navigationStore,
  modalStore,
  authStore
}) => {

  const [confirmDelete, setConfirmDelete] = useState(false)
  const [confirmDeleteData, setConfirmDeleteData] = useState({})

  function _closeConfirmDelete() {
    setConfirmDelete(false)
  }
  async function _submitConfirmDelete(callback) {
    var r = await service.delete(confirmDeleteData.id)
    toast.info(`Data ${confirmDeleteData.nama} telah di hapus.`); callback()
    setConfirmDelete(false)
    TableWrapper.reload(_baseId)
  }

  return (
    <>
    <TableWrapper
      baseId={_baseId}
      title={t.translate('modules.entitas.title')}
      className={className}
      // hintMessage={t.translate('modules.table.hint.message')}
      hintIconClassName="mdi mdi-information"
      hintMore={t.translate('modules.table.hint.more')}
      defaultData={[]}
      defaultSortBy="createdDate"
      columns={[
        {
          label: 'Kode Entitas',
          searchable: true,
          key: 'kodeEntitas',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.kodeEntitas)
        },
        {
          label: 'Nama',
          searchable: true,
          key: 'nama',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.nama)
        },{
          label: 'NPWP',
          searchable: true,
          key: 'npwp',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.npwp)
        },{
          label: 'Alias',
          searchable: true,
          key: 'alias',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.alias)
        },{
          label: 'Alamat Domisili',
          searchable: true,
          key: 'alamat',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.alamat)
        },{
          label: 'Keterangan',
          searchable: true,
          key: 'keterangan',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.keterangan)
        }
      ]}
      actions={[
        new TableWrapper.action('Add', 'mdi mdi-plus', () => history.push('/onpremise/entitas/baru'), authStore.user.roleMap?authStore.user.roleMap['Entitas'].Create:false),
        new TableWrapper.action('Sync', 'mdi mdi-cached', () => {
          modalStore.showConfirm({
            children: "Sinkronisasi data dengan aplikasi pihak ketiga?",
            onRequestClose: () => {
              modalStore.closeConfirm();
            },
            onSubmit: async (callback) => {
              await service.http.post(
                `/entitas-sync`,
                {}
              );
              toast.success(
                `Data telah tersinkronisasi`
              );
              TableWrapper.reload(_baseId);
              callback();
            },
          });
        }, true)
      ]}
      itemActions={[
        new TableWrapper.action('Edit', 'mdi mdi-pencil', (item) => history.push(`/onpremise/entitas/${item.id}`), authStore.user.roleMap?authStore.user.roleMap['Entitas'].Edit:false),
        new TableWrapper.action('Delete', 'mdi mdi-delete', (item) => { setConfirmDeleteData(item); setConfirmDelete(true)}, authStore.user.roleMap?authStore.user.roleMap['Entitas'].Delete:false)
      ]}
      onFetchData={ async query => {
        if(!query) query = {}
        if(sipStore.companyId) {
          query['perusahaanId.equals'] = sipStore.companyId
        }
        console.log('asdasd', JSON.parse(JSON.stringify(authStore)))
        return service.get(query)
      }}
      showCommandbar={showCommandbar}
      showFilterPeriod={false}
    />
    <Modal.Confirm
      // title="Hapus Data"
      visible={confirmDelete}
      onRequestClose={_closeConfirmDelete}
      onSubmit={_submitConfirmDelete}
    >Hapus data {confirmDeleteData.nama}?</Modal.Confirm>
    </>
  )
}

export default inject('sipStore', 'navigationStore',"modalStore", "authStore")(observer(EntitasTable))
